import React from "react";
import Styles from "../styles/components/JsonViewer.module.css";

const JsonViewer = ({ data, indent = 0 }) => {
    if(data === false) {
        return <></>;
    }

    if (typeof data !== "object" || data === null) {
        return <span className={Styles.value}>{String(data)}</span>;
    }

    if (Array.isArray(data)) {
        return (
            <div className={Styles.container}>
                {data.map((item, index) => (
                    <div key={index} style={{ paddingLeft: `${indent + 20}px` }}>
                        <span className={Styles.key}>[{index}]</span>: <JsonViewer data={item} indent={indent + 20} />
                    </div>
                ))}
            </div>
        );
    }

    return (
        <div className={Styles.container}>
            {Object.entries(data).map(([key, value], index) => (
                <div key={index} style={{ paddingLeft: `${indent + 20}px` }}>
                    <span className={Styles.key}>{key}</span>: <JsonViewer data={value} indent={indent + 20} />
                </div>
            ))}
        </div>
    );
};

export default JsonViewer;
